// Card de modelo — markup LITERAL do wireframe §14 (.modc/.modc-top/
// .modc-name/.mbadge/.modc-meta + kebab .skl-kebab; varredura v2 §5.6-C3).
// CSS: src/styles/wf-models.css (+ wf-skills.css pro kebab).
// Card clicável → modal de edição; menu ⋮: Editar configurações · Remover.
// C1: custos via fmtCost → fmtMoneyUSD (vírgula decimal pt-BR).
import { Pencil, Trash2 } from 'lucide-react';
import type { LlmModel } from '@/lib/api';
import { WfKebabMenu, type WfKebabEntry } from '@/components/ui/WfKebabMenu';
import { authFlags, fmtCost, hasReasoning } from './modelHelpers';

interface ModelCardProps {
  model: LlmModel;
  onEdit: (model: LlmModel) => void;
  onDelete: (model: LlmModel) => void;
}

export function ModelCard({ model, onEdit, onDelete }: ModelCardProps) {
  const { oauth, apiKey } = authFlags(model);
  const reasoning = hasReasoning(model);

  const menuItems: WfKebabEntry[] = [
    { key: 'edit', label: 'Editar configurações', icon: Pencil, onSelect: () => onEdit(model) },
    'sep',
    { key: 'delete', label: 'Remover modelo', icon: Trash2, danger: true, onSelect: () => onDelete(model) },
  ];

  return (
    <div
      className="modc"
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if ((e.target as HTMLElement).closest('button, [role="menu"]')) return;
        onEdit(model);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onEdit(model);
        }
      }}
      aria-label={`Modelo ${model.model_key}`}
    >
      {/* Menu ⋮ (wireframe .skl-kebab dentro do .modc) */}
      <WfKebabMenu ariaLabel={`Ações do modelo ${model.model_key}`} items={menuItems} />

      <div className="modc-top">
        <span className="modc-name">{model.model_key}</span>
        {reasoning && <span className="mbadge rs">reasoning</span>}
        {oauth && <span className="mbadge oa">OAuth</span>}
        {apiKey && <span className="mbadge ak">API Key</span>}
        {model.status === 'preview' && <span className="mbadge ak">preview</span>}
      </div>

      <div className="modc-meta">
        <span>
          Entrada <b>{fmtCost(model.input_cost_per_m)}</b>/1M
        </span>
        <span>
          Saída <b>{fmtCost(model.output_cost_per_m)}</b>/1M
        </span>
        {model.notes && <span>{model.notes}</span>}
      </div>
    </div>
  );
}
